<template>
  <div class="spinner">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
</template>

<style scoped>
  .spinner {
    --spinner-color: #fff;
    --spinner-size: 64px;
    
    --spinner-offset: calc( var(--spinner-size) / 2 );
    color: official;
    display: inline-block;
    width: var(--spinner-size);
    height: var(--spinner-size);
    filter: drop-shadow(0 0 10px rgba(0,0,0,0.8));

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .spinner div {
    transform-origin: var(--spinner-offset) var(--spinner-offset);
    animation: lds-spinner 1.2s linear infinite;
  }
  .spinner div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3px;
    left: calc( var(--spinner-size) * 0.453125 );
    width: calc( var(--spinner-size) * 0.078120 );
    height: calc( var(--spinner-size) * 0.21875 );
    border-radius: 20%;
    background: var(--spinner-color);
  }
  .spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }
  .spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
  }
  .spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
  }
  .spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
  }
  .spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
  }
  .spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
  }
  .spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
  }
  .spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
  }
  .spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
  }
  .spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
  }
  .spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
  }
  .spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
  }
  @keyframes lds-spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
</style>